import { CldImage } from "next-cloudinary";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";

import styles from "./CharityCard.module.scss";

const CharityCard = ({ charityData, charityHeader }) => {
  return (
    <div className={`${styles.charityCards}`} id="our-charities">
      <div className="variable-container">
        <h2 className={`${styles.sectionTitle}`}>
          <SectionTitle title="Our Charities" />
        </h2>

        <div className={`${styles.cards}`}>
          {charityData?.map((item, index) => (
            <div className={`${styles.card}`} key={index}>
              <div className={`${styles.imageWrapper}`}>
                <CldImage
                  className={`${styles.image}`}
                  src={item?.charityImage?.data?.attributes?.url}
                  fill
                  alt="Charity image icon"
                  loading={"lazy"}
                  sizes="(min-width: 1200px) 25vw, (min-width: 768px) 50vw, (min-width: 320px) 90vw, 100vw"
                />
              </div>

              <p>{item?.charityDescription}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CharityCard;
